import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang

import locale from 'element-ui/lib/locale'
import enLocale from './en/index.js'
import zhLocale from './zh/index.js'
import myLocale from './my/index.js'
import ptLocale from './pt/index.js'
import { initExtension } from './extension.js'
import { addLangAtHtml } from '@/utils/langFn'
import { langConfig } from '@/lang/langConfig'
import { getStoreSysLang, setStoreSysLang } from '@/lang/langUtils'

Vue.use(VueI18n)

const messages = {
    'en-US': {
        ...enLocale,
        ...elementEnLocale
    },
    'zh-CN': {
        ...zhLocale,
        ...elementZhLocale
    },
    'my' : {
        ...myLocale,
    },
    'pt': {
        ...ptLocale,
    },
}

// 识别语言标识，同步到localStorage，同步到html标签lang属性
const recognizeLangAndSyncStorage = () => {
    const getLangByNaviator = () => {
        const navigatorHtmlLang = navigator.language || navigator.browserLanguage || navigator.userLanguage
        let lang ='';
        // 遍历langConfig，匹配项目已配置的多语言，默认取en
        let isMatch = false
        for (let key in langConfig) {
            if (navigatorHtmlLang == langConfig[key].extLang) {
                lang = key
                isMatch = true
                break
            }
        }
        return lang;
    }

    // localstorage中没有，取浏览器默认语言，需匹配项目已配置的多语言，否则默认英语
    const locale = getStoreSysLang() || getLangByNaviator() || 'en-US'
    !getStoreSysLang() && setStoreSysLang(locale)
    addLangAtHtml(locale)

    return locale
}
const sysLang = recognizeLangAndSyncStorage();

locale.i18n((key, value) => i18n.t(key, value))
const i18n = new VueI18n({
    locale: sysLang,
    messages
})

initExtension(i18n);
export default i18n
